
export default {
  head: {},
  data() {
    return {
      title: this.$t('pricingTitle'),
      description: this.$t('pricingDescription'),
      plan: "yearly",
      services: [
        {
          header: [{ title: this.$t('marketing'), icon: "mdi-bullhorn-outline" }],
          content: [
            {
              title: this.$t('discountCoupons'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('automaticDiscountSystem'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
              offer: true,
            },
            {
              title: this.$t('smsCampaigns'),
              start: "",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: this.$t('orderUpdatesWhatsApp'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('abandonedCartSystem'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('loyaltyPointsSystem'),
              start: "",
              basic: "",
              grow: this.$t('includedInPackageNoAdditionalFee'),
              icon: "/assets/images/icons/Gift.svg",
            },
            {
              title: this.$t('topBannerAds'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('emailMarketing'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('affiliateMarketingSystem'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('marketingLinksSystem'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('backInStockNotification'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('seoOptimization'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
          ],
        },
        {
          header: [{ title: this.$t('integrationServices'), icon: "mdi-source-merge" }],
          content: [
            {
              title: this.$t('analyticsIntegration'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('liveChatIntegration'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('messageServiceIntegration'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('emailServiceIntegration'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('adServiceIntegration'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('zapierIntegration'),
              start: "mdi-check",
              basic: this.$t('comingSoon'),
              grow: this.$t('comingSoon'),
              icon: "/assets/images/icons/zapier.svg",
            },
            {
              title: this.$t('linkArabyIntegration'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
              icon: "/assets/images/icons/link_araby.svg",
            },
            {
              title: this.$t('accountingIntegration'),
              image: "/assets/images/icons/FeatureName.svg",
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
          ],
        },
        {
          header: [{ title: this.$t('storeGrowthTracking'), icon: "mdi-briefcase-upload" }],
          content: [
            {
              title: this.$t('storeGrowthEmployee'),
              start: "",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: this.$t('regularMeetings'),
              start: "",
              basic: this.$t('oneOnlineMeetingAtStart'),
              grow: this.$t('twoOnlineMeetingsMonthly'),
            },
            {
              title: this.$t('marketingToolsSupport'),
              start: "",
              basic: "",
              grow: "mdi-check",
            },
            {
              title: this.$t('storeManagementTips'),
              start: "",
              basic: "",
              grow: "mdi-check",
            },
          ]
        },
        {
          header: [{ title: this.$t('basicServices'), icon: "mdi-key-variant" }],
          content: [
            {
              title: this.$t('unlimitedProducts'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('unlimitedCustomers'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('unlimitedOrders'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('unlimitedSections'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('brandsAndTags'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('storeDomainLink'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('freeDomain'),
              start: "",
              basic: this.$t('annualOnly'),
              grow: this.$t('annualOnly'),
            },
            {
              title: this.$t('sslProtection'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('productReviews'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('productQandA'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('multiOptionProducts'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('productExportImport'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('excelProductUpdate'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('supportForVAT'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('multiCurrencySupport'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('arabicEnglishSupport'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('reportSystem'),
              start: "mdi-check",
              basic: this.$t('basicReports'),
              grow: this.$t('comprehensiveReports'),
            },
            {
              title: this.$t('extraPages'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('customerTestimonials'),
              start: "mdi-check",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('customizableThemes'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
            },
            {
              title: this.$t('salesCommission'),
              start: "0%",
              basic: "0%",
              grow: "0%",
            },
            {
              title: this.$t('panelTeam'),
              start: "mdi-check",
              basic: "2",
              grow: this.$t('unlimited'),
            },
            {
              title: this.$t('storeManagementApp'),
              start: "",
              basic: "mdi-check",
              grow: "mdi-check",
              icon: "/assets/images/icons/GearSix.svg",
            },
          ],
        },
      ],
    };
  },

  head() {
    return {
      title: this.title,
      description: this.description,
      keywords: 'انشاء متجر الكتروني, تصميم متجر الكتروني, تجهيز متجر الكتروني',
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:locale",
          property: "og:locale",
          content: "ar_AR",
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: "https://matjrah.com/prices",
        },
        {
          hid: "og:site_name",
          property: "og:site_name",
          content: "متجرة",
        },
        {
          hid: "og:updated_time",
          property: "og:updated_time",
          content: "2022-12-10T00:08:47+03:00",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: "https://matjrah.com/matjrah.png",
        },
        {
          hid: "apple-mobile-web-app-title",
          name: "apple-mobile-web-app-title",
          content: this.title,
        },
        { name: "twitter:site", content: "@Matjrah" },
        { name: "twitter:card", content: "summary_large_image" },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: "https://matjrah.com/prices",
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.description,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: "https://matjrah.com/matjrah.png",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://matjrah.com/prices",
        },
      ],
    };
  },
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Article",
          "headline": this.title,
          "description": this.description,
          "datePublished": '2022-10-14T10:10:00-07:00',
          "dateModified": '2022-10-14T10:10:00-07:00',
          "publisher": {
            "@type": "Organization",
            "name": "منصة متجرة",
            "logo": {
              "@type": "ImageObject",
              "url": "https://matjrah.com/matjrah.png",
            }
          },
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://matjrah.com/prices"
          },
          "author": { "@type": "Person", "name": "matjrah" },
        }]
    }
  }
};
